import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SavingsPotsStore from '../../stores/SavingsPotsStore';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import InternetBankingActions from '../../actions/InternetBankingActions';
import BrowserUtils from '../../utils/BrowserUtils';

class SavingPotConfirmation extends Component {
  constructor(props) {
    super(props);

    this.handleClickOnOffTransfer = this.handleClickOnOffTransfer.bind(this);
    this.handleClickRegularTransfer =
      this.handleClickRegularTransfer.bind(this);

    this.state = {
      newpotdata: SavingsPotsStore.getCreatedPotData(),
    };
  }

  handleClickOnOffTransfer() {
    // accid and pot id and amount(kick amonut)
    const { getSelectedAccountID, getPotPageHandleClick } = this.props;
    const {
      newpotdata: {
        id,
        schedule: {
          recurrence: {
            amount: { value },
          },
        },
      },
    } = this.state;
    const data = {
      id: getSelectedAccountID,
      potId: id,
      amt: SavingsPotsStore.getPotBalanceStoreValue(),
      amt2: value,
      isMonthly: false,
    };
    SavingPotsActionCreator.handleTransferMoney(data);
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY');
    getPotPageHandleClick();
  }

  handleClickRegularTransfer() {
    // Monthly Payment, accid and pot id
    const { getSelectedAccountID, getPotPageHandleClick } = this.props;
    const {
      newpotdata: {
        id,
        schedule: {
          recurrence: {
            amount: { value },
          },
        },
      },
    } = this.state;

    const data = {
      id: getSelectedAccountID,
      potId: id,
      amt2: value,
      isMonthly: true,
    };
    SavingPotsActionCreator.handleTransferMoney(data);
    InternetBankingActions.navigateToWebTask('WEB-OPEN-MOVEMONEY');
    getPotPageHandleClick();
  }

  render() {
    let doneButtonContent;
    let doneButtonContentMobile;
    let cancelButton;
    let paymentOption;
    const {
      getPotPageHandleClick,
      content: {
        savingDone,
        savingsPotConfirmationTransferMobile,
        savingsPotCancelButton,
        savingsPotConfirmationTransfer,
        savingsPotConfirmationMessage,
        savingsPotConfirmationTransferRegular,
      },
    } = this.props;

    if (BrowserUtils.isMobileView()) {
      doneButtonContentMobile = (
        <button className="page-options" onClick={getPotPageHandleClick}>
          {savingDone}
        </button>
      );
      cancelButton = '';
      paymentOption = savingsPotConfirmationTransferMobile;
    } else {
      doneButtonContent = (
        <button onClick={getPotPageHandleClick} className="action-button white">
          {savingDone}
        </button>
      );
      cancelButton = (
        <button className="page-options" onClick={getPotPageHandleClick}>
          {savingsPotCancelButton}
        </button>
      );
      paymentOption = savingsPotConfirmationTransfer;
    }
    return (
      <div>
        <div className="main-container page create-pot-success">
          <div className="text-center full-height">
            <div className="success__header row no-gutters text-right">
              <div className="col-xs-3 text-left">{cancelButton}</div>
              <div className="col-xs-6 text-right" />
              <div className="col-xs-3 text-right">
                {doneButtonContentMobile}
              </div>
            </div>
            <div className="success__content">
              <h2>{savingsPotConfirmationMessage}</h2>
              <div className="check-image">
                <span className="icon icon-done" />
                <ul>
                  <li>
                    <a
                      href="javascript:void(0);"
                      onClick={this.handleClickOnOffTransfer}
                      className="page-options"
                    >
                      <i className="icon icon-move" />
                      {paymentOption}
                    </a>
                  </li>
                  <li>
                    <a
                      href="javascript:void(0);"
                      onClick={this.handleClickRegularTransfer}
                      className="page-options"
                    >
                      <i className="icon icon-move" />
                      {savingsPotConfirmationTransferRegular}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            {doneButtonContent}
          </div>
        </div>
      </div>
    );
  }
}

SavingPotConfirmation.propTypes = {
  getPotPageHandleClick: PropTypes.func,
  accountClass: PropTypes.string,
  content: PropTypes.object,
  getSelectedAccountID: PropTypes.string,
};

export { SavingPotConfirmation };
